import type { Task } from '../../types/task'
import { getOfflineDb } from '../dbFactory'
import type { TaskRepo } from './TaskRepo'

export const dexieTaskRepo: TaskRepo = {
  async list() {
    return getOfflineDb().tasks.orderBy('updatedAt').toArray()
  },

  async get(id) {
    return getOfflineDb().tasks.get(id)
  },

  async upsert(task) {
    await getOfflineDb().tasks.put(task)
  },

  async upsertMany(tasks) {
    await getOfflineDb().tasks.bulkPut(tasks)
  },

  async replaceAll(tasks) {
    const db = getOfflineDb()
    await db.transaction('rw', db.tasks, async () => {
      await db.tasks.clear()
      if (tasks.length > 0) {
        await db.tasks.bulkPut(tasks)
      }
    })
  },

  async remove(id) {
    await getOfflineDb().tasks.delete(id)
  },

  async clear() {
    await getOfflineDb().tasks.clear()
  }
}
